import { Badge, HStack, Text } from "@chakra-ui/react";
import {
  components,
  GroupBase,
  OptionProps,
  SingleValueProps,
} from "react-select";
import {
  INCLUSION_LIST_TYPES,
  MEMBERSHIP_ASSET_TYPES,
} from "../common/types/campaign";
import { AssetSpecificBadge, AssetField } from "../common/types/connection";
import { PersonDestination } from "../common/types/person";

const display = {
  [MEMBERSHIP_ASSET_TYPES.CAMPAIGN]: "Dynamic List",
  [MEMBERSHIP_ASSET_TYPES.STATIC_LIST]: "static_list",
  [INCLUSION_LIST_TYPES.DYNAMIC]: "Dynamic List",
  [INCLUSION_LIST_TYPES.STATIC]: "static_list",
};

export const CustomAssetBadgeOption = ({
  children,
  data,
  ...props
}: OptionProps<AssetField, false, GroupBase<AssetField>>) => {
  return (
    <HStack
      justifyContent="space-between"
      alignItems="baseline"
      py="2"
      px="3"
      bg={props.isSelected ? "#E2E8F0" : ""}
      _hover={props.isSelected ? {} : { bg: "#EDF2F7" }}
      onClick={() => props.setValue(data, "select-option")}
    >
      <Text fontSize="sm" isTruncated maxW="800px">
        {data.name}
      </Text>
      <Badge
        fontSize="10px"
        backgroundColor={AssetSpecificBadge[data.type].color}
        variant="solid"
      >
        {display[data.type]}
      </Badge>
    </HStack>
  );
};

export function AssetNameWithTag({
  data,
  quotes,
}: {
  data: AssetField | null;
  quotes?: boolean;
}) {
  return (
    <HStack justifyContent="space-between">
      <Text
        maxW="100%"
        whiteSpace="nowrap"
        overflow="hidden"
        textOverflow="ellipsis"
      >
        {quotes ? `"${data?.name}"` : data?.name}
      </Text>
      {data && (
        <Badge
          fontSize="10px"
          backgroundColor={AssetSpecificBadge[data.type].color}
          variant="solid"
          flex="0 0 fit-content"
        >
          {display[data.type]}
        </Badge>
      )}
    </HStack>
  );
}

export function CustomSingleValue({
  children,
  ...props
}: SingleValueProps<AssetField, false, GroupBase<AssetField>>) {
  const values = props.getValue();
  const data = values.length ? values[0] : null;

  return (
    <components.SingleValue {...props}>
      <AssetNameWithTag data={data} />
    </components.SingleValue>
  );
}

export const CustomOptionWithRequired = ({
  children,
  data,
  ...props
}: OptionProps<PersonDestination, false, GroupBase<PersonDestination>>) => {
  return (
    <HStack
      justifyContent="space-between"
      alignItems="baseline"
      py="2"
      px="3"
      bg={props.isSelected ? "gray.200" : ""}
      _hover={props.isSelected ? {} : { bg: "gray.100" }}
      onClick={() => props.setValue(data, "select-option")}
    >
      <Text fontSize="sm" isTruncated maxW="800px">
        {data.display}
      </Text>
      {data.required ? (
        <Badge
          fontSize="10px"
          backgroundColor="oneOffs.tableheader"
          variant="solid"
        >
          Required
        </Badge>
      ) : (
        <></>
      )}
    </HStack>
  );
};
